import type { AffectedHauler } from './hooks';

/**
 * How an affected hauler is linked to the changed well, in plain words (#55):
 * "2 tank batteries (North TB, South TB) · pickup well · disposal well". A part whose
 * count is zero is left out. The API sends all three counts (migration 0185).
 */
export function linkLabel(
  h: Pick<AffectedHauler, 'batteryCount' | 'batteryNames' | 'pickupCount' | 'disposalCount'>,
): string {
  const parts: string[] = [];
  if (h.batteryCount > 0) {
    const n = `${h.batteryCount} tank batter${h.batteryCount === 1 ? 'y' : 'ies'}`;
    parts.push(h.batteryNames !== null ? `${n} (${h.batteryNames})` : n);
  }
  if (h.pickupCount > 0) parts.push('pickup well');
  if (h.disposalCount > 0) parts.push('disposal well');
  // Every count 0 only if a link was removed between the list and this read.
  return parts.length > 0 ? parts.join(' · ') : 'linked to this well';
}
